class BlockExpertises {
	constructor() {
		this.block = document.querySelector(".block-expertises");

		if (! this.block) {
			return;
		}

		this.buildAnim();
	}

	buildAnim() {
		const anim = this.block.querySelector('[data-load-svg-animation]');
		lottie.loadAnimation({
			container: anim,
			renderer: 'svg',
			loop: true,
			autoplay: true,
			path: anim.dataset.loadSvgAnimation,
			name: anim.dataset.lottieName
		});
	}
}